import React, { Component } from 'react';
import { Spin, Table, Input, Button, Modal, message, Divider, Tooltip } from 'antd';
import { connect } from 'dva';
import { stringify } from 'qs';
import SelectUser from 'nbugs-select-user-pc';
import { router } from 'umi';
// import MemberModal from '../components/MemberModal';
import { ENV } from '@/services/utils';
import { downloadUrl, uploadUrl, downloadUsersUrl } from '../services/Tags';
import downFile from '../services/downFile';
import Edit from '../components/EditModal';
import AddModal from '../components/AddModal';
import Container from '../../../../../components/Container';
import UploadModal from '../../companents/UploadModal';
import styles from './index.less';

const { Search } = Input;
const { confirm } = Modal;

@connect(({ tags, loading }) => ({
  ...tags,
  loading: loading.effects['tags/fetchMemberList'],
}))
class UserTagsView extends Component {
  constructor(props) {
    super(props);

    this.tagType = 1; // 定义标签类型 1-组织标签 2-个人标签

    const columns = [
      {
        title: '标签名称',
        dataIndex: 'alias',
        width: '40%',
        render: record => (
          <Tooltip title={record} placement="topLeft">
            <div className="table-th-icon ellipsis">{record}</div>
          </Tooltip>
        ),
      },
      {
        title: '成员数量',
        // dataIndex: 'num',
        width: '20%',
        render: record => (
          <span className="table-action-box">
            <a
              className="table-action-edit"
              onClick={event => this.handleJumpMember({ record, event })}
            >
              {record.num}
            </a>
          </span>
        ),
      },
      {
        title: '操作',
        dataIndex: '',
        width: '40%',
        render: record => (
          <span className="table-action-box">
            <a
              className="table-action-edit"
              onClick={event => this.handleEdit({ visible: true, record, event })}
            >
              重命名
            </a>
            <Divider type="vertical" />
            <SelectUser
              appId={ENV === 'production' ? '37' : '73'}
              appName="标签管理"
              selectType="user"
              orgType="county"
              isReset
              // selectSignature={selectSignature} 不再传入之前的选择
              // getCheckedNodes={this.getCheckedNodes}
              onCancel={this.handleCancelSelectUser}
              onOk={this.handleConfirm}
              onError={this.handleError}
              renderSelectBtn={({ handleSelectUserStatusChange }) => {
                return (
                  <a
                    className="table-action-edit"
                    onClick={event =>
                      this.handleSelectUserModal({ handleSelectUserStatusChange, record, event })
                    }
                  >
                    增加人员
                  </a>
                );
              }}
            />
            <Divider type="vertical" />
            <a
              className="table-action-edit"
              onClick={event => this.handleClickUpload({ record, event })}
            >
              导入
            </a>
            <Divider type="vertical" />
            <a
              className="table-action-edit"
              onClick={event => this.handleClickExport({ record, event })}
            >
              导出
            </a>
            <Divider type="vertical" />
            <a className="table-action-edit" onClick={event => this.handleDelete(record, event)}>
              删除
            </a>
          </span>
        ),
      },
    ];

    this.state = {
      searchValue: '',
      columns,
      currentPage: 1,
      editModalInfo: {
        data: {},
        visible: false,
      },
      addModalVisible: false, // 新建modal 显示状态
      currentTagId: null, // 当前选中tagid
      pageSize: 20,
      uploadModalVisibale: false, // 显示上传modal
    };
  }

  componentDidMount() {
    this.getList();
  }

  getList = name => {
    const { dispatch } = this.props;
    const { currentPage, pageSize } = this.state;
    dispatch({
      type: 'tags/fetchList',
      payload: {
        page: currentPage,
        pageSize,
        name,
        type: this.tagType,
      },
    });
  };

  handleEdit = ({ visible = false, record = {}, event } = {}) => {
    if (event) {
      event.stopPropagation();
    }

    this.setState({
      editModalInfo: {
        data: record,
        visible,
      },
    });
  };

  handleJumpMember = ({ record }) => {
    const { id, alias: name } = record;
    router.push(
      `/countyContacts/tags/user?${stringify({
        currentTagId: id,
        currentTagType: this.tagType,
        currentTagName: name,
      })}`
    );
  };

  handleSelectUserModal = ({ handleSelectUserStatusChange, record = {}, event } = {}) => {
    handleSelectUserStatusChange();
    if (event) {
      event.stopPropagation();
    }
    const { id } = record;
    this.setState({
      currentTagId: id,
    });
    this.getSelectUserList(id);
  };

  getSelectUserList = tagId => {
    const { dispatch } = this.props;
    dispatch({
      type: 'tags/getSelectUserList',
      payload: {
        tagId,
      },
    });
  };

  handleEditTagName = ({ id, alias }) => {
    const { dispatch } = this.props;
    dispatch({
      type: 'tags/fetchEditTagName',
      payload: {
        id,
        alias,
        type: this.tagType,
      },
      calback: () => {
        this.handleEdit();
        this.getList();
      },
    });
  };

  handleChangeSize = (current, pageSize) => {
    const { searchValue } = this.state;
    this.setState(
      {
        currentPage: current,
        pageSize,
      },
      () => {
        this.getList(searchValue);
      }
    );
  };

  handleChangePagination = (page, pageSize, callback) => {
    const { searchValue } = this.state;
    this.setState(
      {
        currentPage: page,
        pageSize,
      },
      () => {
        if (callback && Object.prototype.toString.call(callback) === '[object Function]') {
          callback();
        } else {
          this.getList(searchValue);
        }
      }
    );
  };

  handleSearch = val => {
    const { pageSize } = this.state;

    this.setState({
      searchValue: val,
    });
    // this.getList(val);
    if (!val && !val.trim().length) {
      this.handleChangePagination(1, pageSize, this.getList);
    } else {
      this.handleChangePagination(1, pageSize, () => this.getList(val));
    }
  };

  handleClickAddBtn = () => {
    this.setState({
      addModalVisible: true,
    });
  };

  // 取消显示新建modal
  handleCancelAdd = () => {
    this.setState({
      addModalVisible: false,
    });
  };

  // 提交新建标签
  handleAddDept = params => {
    const { dispatch } = this.props;
    dispatch({
      type: 'tags/fetchAddTag',
      payload: {
        ...params,
        type: this.tagType,
      },
      callback: () => {
        this.handleCancelAdd();
        this.getList();
      },
    });
  };

  // table选中
  handleSelectedChange = selectedRowKeys => {
    const { dispatch } = this.props;

    dispatch({
      type: 'tags/save',
      payload: { selectedRowKeys },
    });
  };

  // 单个删除
  handleDelete = ({ id, alias }, event) => {
    if (event) {
      event.stopPropagation();
    }
    const { dispatch, totalElements } = this.props;
    const { currentPage, pageSize } = this.state;
    const callback = () => {
      let countPage = currentPage;
      if (totalElements - (currentPage - 1) * pageSize === 1) {
        countPage = currentPage - 1;
      }
      this.handleChangePagination(countPage, pageSize);
      // this.getList()
      this.handleSelectedChange([]);
    };
    confirm({
      title: `删除标签？`,
      content: `确认删除 “${alias}” 标签吗？`,
      okText: '确定',
      cancelText: '取消',
      onOk: () => {
        dispatch({
          type: 'tags/fetchDelete',
          payload: {
            idList: [id],
          },
          callback,
        });
      },
    });
  };

  // 批量删除
  handleDeleteTags = () => {
    const { dispatch, selectedRowKeys } = this.props;

    if (!selectedRowKeys || selectedRowKeys.length === 0) {
      message.error('请至少选中一个标签');
      return null;
    }

    confirm({
      title: `删除多个标签？`,
      content: '是否确认删除',
      okText: '确定',
      cancelText: '取消',
      onOk: () => {
        dispatch({
          type: 'tags/fetchDelete',
          payload: {
            idList: selectedRowKeys,
          },
          callback: () =>
            this.handleChangePagination(1, 10, () => {
              this.getList();
              this.handleSelectedChange([]);
            }),
        });
      },
    });
    return null;
  };

  handleClickUpload = ({ record, event }) => {
    if (event) {
      event.stopPropagation();
    }

    const { id: currentTagId } = record;
    this.handleUpload(true, currentTagId);
  };

  handleClickExport = ({ record, event }) => {
    if (event) {
      event.stopPropagation();
    }
    const { id: currentTagId } = record;
    const url = `${downloadUsersUrl}?${stringify({ tagId: currentTagId, type: 1 })}`;
    downFile({
      url,
    });
  };

  handleUpload = (uploadModalVisibale = false, currentTagId = null) => {
    this.setState(
      {
        uploadModalVisibale,
        currentTagId,
      },
      () => {
        if (!uploadModalVisibale) {
          this.getList();
        }
      }
    );
  };

  // 选人组件
  handleConfirm = data => {
    const { currentTagId } = this.state;
    const { dispatch } = this.props;
    const { selectSignature } = data;

    dispatch({
      type: 'tags/submitAddUser',
      payload: {
        tagId: currentTagId,
        selectList: [
          {
            type: this.tagType,
            selectId: selectSignature,
          },
        ],
      },
      callback: () => {
        this.handleCancelSelectUser();
        this.getList();
      },
    });
  };

  handleCancelSelectUser = () => {
    const { dispatch } = this.props;
    dispatch({
      type: 'tags/save',
      payload: {
        selectSignature: '',
      },
    });
  };

  handleError = err => {
    message.error(err);
  };

  // 渲染选中信息
  renderTableTitle = () => {
    const { selectedRowKeys } = this.props;

    return (
      <>
        {!!selectedRowKeys.length && (
          <div className="table-selected-info">
            已选 <span>{selectedRowKeys.length}</span> 标签
          </div>
        )}
      </>
    );
  };

  renderTable = () => {
    const { dataSource, totalElements, selectedRowKeys } = this.props;
    const { columns, currentPage } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.handleSelectedChange,
    };
    const tableProps = {
      title: this.renderTableTitle,
      rowSelection,
      rowKey: 'id',
      columns,
      dataSource,
      pagination: {
        total: totalElements,
        showSizeChanger: true,
        pageSizeOptions: ['20', '50', '100', '200'],
        showQuickJumper: true,
        current: currentPage,
        defaultPageSize: 20,
        onChange: this.handleChangePagination,
        onShowSizeChange: this.handleChangeSize,
      },
    };

    if (totalElements > 0) {
      tableProps.footer = () => (
        <div className="table-footer">{`共 ${totalElements} 条记录 第 ${currentPage} 页`}</div>
      );
    }
    return (
      <div className="table-wrap">
        <Table {...tableProps} />
      </div>
    );
  };

  render() {
    const {
      editModalInfo,
      addModalVisible,
      uploadModalVisibale,
      currentTagId,
    } = this.state;
    const { spinProps } = this.props;
    const { visible } = editModalInfo;

    return (
      <Container breStates defaultPadding>
        <div className={styles.userTags}>
          <div className="content-container">
            <Spin {...spinProps}>
              <div className="header-wrap">
                <div className="left">
                  <Button type="primary" onClick={this.handleClickAddBtn}>
                    添加标签
                  </Button>
                  <Button onClick={this.handleDeleteTags}>批量删除标签</Button>
                </div>
                <div className="right">
                  <Search
                    style={{ width: 300 }}
                    placeholder="搜索标签名称"
                    onSearch={this.handleSearch}
                  />
                </div>
              </div>
              {this.renderTable()}
              {!!visible && (
                <Edit
                  {...editModalInfo}
                  handleEdit={this.handleEdit}
                  handleEditDeptName={this.handleEditTagName}
                />
              )}
              {!!addModalVisible && (
                <AddModal
                  extra="注意：标签名称用于排序，填写数字可按数字排序"
                  handleCancel={this.handleCancelAdd}
                  handleAddDept={this.handleAddDept}
                />
              )}
              {uploadModalVisibale && (
                <UploadModal
                  uploadData={{ tagId: currentTagId }}
                  onCancel={() => this.handleUpload(false)}
                  onOk={() => this.handleUpload(false)}
                  downUrl={downloadUrl}
                  actionUrl={uploadUrl}
                  title="批量导入人员"
                />
              )}
            </Spin>
          </div>
        </div>
      </Container>
    );
  }
}

export default UserTagsView;
